<template>
  <footer class="app-footer">
    <div class="footer-content">
      <img src="@/assets/partenaires-rayuwa.jpg" alt="Partenaires" class="partenaires-logo" />
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
.app-footer {
  background-color: white;
  padding: 0.5rem;
  margin-top: auto;
  border-top: 1px solid #e5e7eb;

  .footer-content {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;

    .partenaires-logo {
      max-height: 60px;
      width: auto;
    }
  }
}
</style> 